import { MinLength, MaxLength } from "class-validator";
import {
    validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
    IsDate, Min, Max
} from "class-validator";
import { ValidateIf, IsNotEmpty, IsNumber, IsString, IsEmpty } from "class-validator";


export class Sysse {
    @MaxLength(10, { message: 'COMPANY 字串太長' })
    @IsString({ message: 'COMPANY 不是字串型態' })
    COMPANY: string = "";

    @MaxLength(10)
    CREATOR: string = "";

    @MaxLength(10)
    USR_GROUP: string = "";

    @MaxLength(8)
    CREATE_DATE: string = "";

    @MaxLength(10)
    MODIFIER: string = "";

    @MaxLength(8)
    MODI_DATE: string = "";

    @IsNumber()
    @Max(999)
    FLAG: number = 0;


    @MaxLength(30, { message: '公司代號 (COMPANYID) 資料太長' })
    COMPANYID: string = '';            // 公司代號 30 OLD：10

    @MaxLength(15, { message: '鎖定工作電腦 (COMPUTER) 資料太長' })
    COMPUTER: string = '';            // 鎖定工作電腦 15 若有設定則派班只能在此電腦跑


    DTREQUEST: Date | undefined;            // 設定時間 0 

    @MaxLength(4, { message: '每日時分 (HHMM) 資料太長' })
    HHMM: string = '0300';            // 每日時分 4 [DEF:"0300"]

    @IsNotEmpty({ message: '定時工作代號 (JOBID) 不可空白' })
    @MaxLength(14, { message: '定時工作代號 (JOBID) 資料太長' })
    JOBID: string = '';            // 定時工作代號 14 

    @MaxLength(255, { message: '程式名稱 (NAME1) 資料太長' })
    NAME1: string = '';            // 程式名稱 255 API 程式名稱

    @MaxLength(1, { message: '結案碼 (OK) 資料太長' })
    OK: string = 'N';            // 結案碼 1 [DEF:"N"]

    @MaxLength(4000, { message: '參數內容 (PARAM1) 資料太長' })
    PARAM1: string = '';            // 參數內容 4000 

    @IsNumber()
    PRIORITY: number = 0;            // 優先權 2 {{1:最優先 2:普通}}

    @MaxLength(20, { message: '程式代號 (PROGID) 資料太長' })
    PROGID: string = '';            // 程式代號 20 

    @MaxLength(30, { message: '變動欄位 (SE100) 資料太長' })
    SE100: string = '';            // 變動欄位 30 JKRange:Date or JKBtnEdit:Date  YYMM 先沒有

    @MaxLength(1, { message: '頻率類型 (SE101) 資料太長' })
    SE101: string = 'D';            // 頻率類型 1 [DEF:"D"] {{H:小時 D:每日 W:每週 M:每月}}

    @IsNumber()
    SE102: number = 1;            // 重複頻率 6 [DEF:1]

    @MaxLength(4, { message: '保留 (SE103) 資料太長' })
    SE103: string = '';            // 保留 4 執行時間

    @MaxLength(4, { message: '時間範圍-起 (SE104) 資料太長' })
    SE104: string = '0000';            // 時間範圍-起 4 [DEF:"0000"]

    @MaxLength(4, { message: '時間範圍-迄 (SE105) 資料太長' })
    SE105: string = '2359';            // 時間範圍-迄 4 [DEF:"2359"]

    @MaxLength(8, { message: '開始日期 (SE106) 資料太長' })
    SE106: string = '';            // 開始日期 8 

    @MaxLength(8, { message: '結束日期 (SE107) 資料太長' })
    SE107: string = '';            // 結束日期 8 

    @IsNumber()
    SE108: number = 0;            // 每月執行日 8 

    @MaxLength(8, { message: '下次日期 (SE109) 資料太長' })
    SE109: string = '';            // 下次日期 8 

    @MaxLength(4, { message: '下次時間 (SE110) 資料太長' })
    SE110: string = '';            // 下次時間 4 

    @MaxLength(8, { message: '計劃開始日期 (SE111) 資料太長' })
    SE111: string = '';            // 計劃開始日期 8 

    @MaxLength(4, { message: '計劃開始時間 (SE112) 資料太長' })
    SE112: string = '';            // 計劃開始時間 4 

    @MaxLength(255, { message: '備註 (SE113) 資料太長' })
    SE113: string = '';            // 備註 255 

    @MaxLength(255, { message: '變動欄位公式-起 (SE114) 資料太長' })
    SE114: string = '';            // 變動欄位公式-起 255 

    @MaxLength(255, { message: '變動欄位公式-迄 (SE115) 資料太長' })
    SE115: string = '';            // 變動欄位公式-迄 255 

    @MaxLength(1, { message: 'MAIL通知方式 (SE116) 資料太長' })
    SE116: string = '';            // MAIL通知方式 1 -->SYS.KA019 {{ :不通知 1:有錯誤通知 2:有錯誤或警告通知 3:完成就通知}}

    @MaxLength(255, { message: 'MAIL帳號 (SE117) 資料太長' })
    SE117: string = '';            // MAIL帳號 255 可多個MAIL 逗號分開

    @MaxLength(1, { message: '工作類型 (STYLE) 資料太長' })
    STYLE: string = 'B';            // 工作類型 1 [DEF:"B"]  {{B:批次 R:報表 A:API批次}}  <-->SYSKA.KA008

    @MaxLength(10, { message: '使用者代號 (USERID) 資料太長' })
    USERID: string = '';            // 使用者代號 10 

    @MaxLength(1, { message: '週一 (WEEK1) 資料太長' })
    WEEK1: string = 'Y';            // 週一 1 [DEF:"Y"]

    @MaxLength(1, { message: '週二 (WEEK2) 資料太長' })
    WEEK2: string = 'Y';            // 週二 1 [DEF:"Y"]

    @MaxLength(1, { message: '週三 (WEEK3) 資料太長' })
    WEEK3: string = 'Y';            // 週三 1 [DEF:"Y"]

    @MaxLength(1, { message: '週四 (WEEK4) 資料太長' })
    WEEK4: string = 'Y';            // 週四 1 [DEF:"Y"]

    @MaxLength(1, { message: '週五 (WEEK5) 資料太長' })
    WEEK5: string = 'Y';            // 週五 1 [DEF:"Y"]

    @MaxLength(1, { message: '週六 (WEEK6) 資料太長' })
    WEEK6: string = 'Y';            // 週六 1 [DEF:"Y"]

    @MaxLength(1, { message: '週日 (WEEK7) 資料太長' })
    WEEK7: string = 'Y';            // 週日 1 [DEF:"Y"]


}
